let mapLayers = [
    { name: "Avverkningsanmälan", layer: "Avverkningsanmalan_Skogsstyrelsen", url: "https://geodpags.skogsstyrelsen.se/arcgis/services/Geodataportal/GeodataportalVisaAvverkningsanmalan/MapServer/WmsServer?" },
    { name: "Utförd avverkning", layer: "UtfordAvverkning_Skogsstyrelsen", url: "https://geodpags.skogsstyrelsen.se/arcgis/services/Geodataportal/GeodataportalVisaUtfordavverkning/MapServer/WmsServer?" },
    { name: "Object med naturvärde", layer: "Objektnaturvarde_Skogsstyrelsen", url: "https://geodpags.skogsstyrelsen.se/arcgis/services/Geodataportal/GeodataportalVisaObjektnaturvarde/MapServer/WmsServer?" },
    { name: "Sumpskog", layer: "Sumpskog_Skogsstyrelsen", url: "https://geodpags.skogsstyrelsen.se/arcgis/services/Geodataportal/GeodataportalVisaSumpskog/MapServer/WmsServer" },
    { name: "Observationer invasiva arter", layer: "SpeciesObservationsInvasive", url: "https://sosgeo.artdata.slu.se/geoserver/SOS/wms" },
    { name: "Torvmark", layer: "Torvkarta_1_0:SKS_Torv", url: "/wms-proxy-torvmark/" },
    { name: "Vattenskyddsområden", layer: "PS.ProtectedSites.VSO", url: "https://geodata.naturvardsverket.se/inspire/ps-nvr/ows" },
    { name: "Observationer rödlistade arter", layer: "SpeciesObservationsRedlisted", url: "https://sosgeo.artdata.slu.se/geoserver/SOS/wms" },
    { name: "Avdelnings nr", layer: "Avdelnings nr", url:""},
    { 
        name: "Nyckelbiotoper", 
        layer: "Nyckelbiotop_Skogsstyrelsen", 
        url: "https://geodpags.skogsstyrelsen.se/arcgis/services/Geodataportal/GeodataportalVisaNyckelbiotop/MapServer/WmsServer?", 
        extraData: (data) => {
            let infoKeys = ['Beteckn', 'Biotop1', 'Biotop2', 'Biotop3', 'Beskrivn1', 'Beskrivn2', 'Beskrivn3', 'Url']
            let elems = data.documentElement.querySelectorAll("FIELDS")
            let output = {}
            elems.forEach(itm => {
                infoKeys.forEach(key => {
                    output[key] = itm.getAttribute(key)
                });
            })
            return output
        }, 
    },
    { 
        name: "Fornlämningar", 
        layer: "fornlamning", 
        url: "https://pub.raa.se/visning/lamningar_v1/wms", 
        extraData: (data) => {
            let infoKeys = ['lamningsnummer', 'raa_nummer', 'lamningstyp', 'egenskap', 'senast_publicerad', 'url']
            let output = {}
            infoKeys.forEach(key => {
                let elem = data.documentElement.getElementsByTagName("lamningar_v1:" + key)[0]
                if(elem) {
                    output[key] = elem.innerHTML.toString()
                }
            })
            return output
        },
    }
]


const baseMaps = [
    { name: "Mapbox Plain", url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', config: { attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>', maxZoom: 18, id: 'virkesborsen/cl3oe50md007w14mltp5laxhv', tileSize: 512, zoomOffset: -1, accessToken: 'pk.eyJ1Ijoidmlya2VzYm9yc2VuIiwiYSI6ImNsM29lMHJ6dDBsbm8zamxudWYzOW5pcWQifQ.e1McEtWBLaLRbDP7sBQ0Ww' } },
    { name: "Mapbox Satelite", url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', config: { attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>', maxZoom: 18, id: 'virkesborsen/cl9zfrqh0006514pld9wn4229', tileSize: 512, zoomOffset: -1, accessToken: 'pk.eyJ1Ijoidmlya2VzYm9yc2VuIiwiYSI6ImNsM29lMHJ6dDBsbm8zamxudWYzOW5pcWQifQ.e1McEtWBLaLRbDP7sBQ0Ww' } },
    { name: "Mapbox Satelite Borders", url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', config: { attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>', maxZoom: 18, id: 'virkesborsen/cm0f62g2i00xq01qs60nv5uah', tileSize: 512, zoomOffset: -1, accessToken: 'pk.eyJ1Ijoidmlya2VzYm9yc2VuIiwiYSI6ImNsM29lMHJ6dDBsbm8zamxudWYzOW5pcWQifQ.e1McEtWBLaLRbDP7sBQ0Ww' } },
    { name: "Open Street Map", url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', config: { maxZoom: 18, tileSize: 512, zoomOffset: -1 } },
    { name: "ESA Worldcover", type: "wms", url: "https://services.terrascope.be/wms/v2", config: {layers: "WORLDCOVER_2021_S2_TCC", transparent: true, tiled: true, f: 'pjson', format: 'image/png', identify: false, zIndex: 1000} },
    {name: "Google Satelite", url:'http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}', config:{ maxZoom: 18, id: 'mapbox/streets-v11', tileSize: 512, zoomOffset: -1, crossOrigin: 'None' }},
]
let polyIcon= null
let moveIcon = null
let resizeIcon = null

if (typeof window !== 'undefined' && typeof window.L !== 'undefined') {
    
    polyIcon = new L.divIcon({className: 'leaflet-poly-icon', html: '' })

    moveIcon = new L.divIcon({className: 'leaflet-move-icon', html: '' })

    resizeIcon = new L.divIcon({className: 'leaflet-resize-icon', html: '' })
}

function swapCoords(coords) {
    return coords.map(c => c.map(g => [g[1], g[0]]))
}

export {mapLayers, baseMaps, polyIcon, moveIcon, resizeIcon, swapCoords}